import Styles from 'components/Wizards/Wizard/Header/Header.module.scss'
import { Stepper } from 'components/Wizards/Stepper/Stepper'
import { HeaderProps } from 'components/Wizards/Wizard/Header/Types'
import { Text } from 'blaze-ui/Text/Text'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useCallback } from 'react'

export const Header = ({
  steps,
  currentStep = 1,
  onClose,
  onStepPress,
  stepperVariant,
  title,
  icon: Icon,
  previewUrl,
  completedAll,
  hiddenStepIndexes,
  withCloseButton = true,
  ...domAttributes
}: HeaderProps) => {
  const { closeModal } = useModals()
  const { isMobile } = useResponsiveDesign()
  const isDesktopWizardsUpdatesOn = useFlipperFlag('desktop_wizards_updates')

  const handleClose = useCallback(() => {
    onClose?.()
    closeModal()
  }, [closeModal, onClose])

  if (isDesktopWizardsUpdatesOn && !isMobile) {
    return (
      <div className={Styles.root}>
        <div className={Styles.titleContainer}>
          {!!Icon && <Icon size={20} />}
          <Text variant="smallList" color="var(--dark-80)" {...{ id: 'wizard-header', ...domAttributes }}>
            {title}
          </Text>
        </div>
        <Stepper.Root
          current={currentStep}
          variant={stepperVariant}
          completedAll={completedAll}
          hiddenStepIndexes={hiddenStepIndexes}
        >
          {steps.map((step, i) => (
            <Stepper.Step onPress={() => onStepPress?.(i + 1)} key={`${step}_${i}`}>
              {step}
            </Stepper.Step>
          ))}
        </Stepper.Root>
        {withCloseButton ? (
          <Button variant="editor" size="sm" onPress={handleClose}>
            Cancel
          </Button>
        ) : (
          <div className={Styles.spacer} />
        )}
      </div>
    )
  }

  return (
    <div className={Styles.root}>
      <Stepper.Root
        current={currentStep}
        variant={stepperVariant}
        completedAll={completedAll}
        hiddenStepIndexes={hiddenStepIndexes}
      >
        {steps.map((step, i) => (
          <Stepper.Step onPress={() => onStepPress?.(i + 1)} key={`${step}_${i}`}>
            {step}
          </Stepper.Step>
        ))}
      </Stepper.Root>
      <div className={Styles.titleContainer}>
        {!!Icon && <Icon size={20} />}
        <Text variant="smallList" color="var(--dark-80)" {...{ id: 'wizard-header', ...domAttributes }}>
          {title}
        </Text>
      </div>
    </div>
  )
}
